<template>
  <slot :header="pumpRowHeader"></slot>
</template>

<script setup lang="ts">
import type { XrefPumps } from "@/composables/forms/formTypes";

import { computed, toRefs } from "vue";
import { usePumpRowHeader } from "./usePumpRowHeader";
import { injectStrict } from "@/utils/utils";
import { scenarioCalculationsKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";

const props = defineProps<{
  xrefPump: XrefPumps[number];
  order?: XrefPumps;
}>();

const scenarioCalculations = injectStrict(scenarioCalculationsKey);
const { descendingOrderPumps } = scenarioCalculations;

const { xrefPump, order } = toRefs(props);

// Prefer the stack-specific order passed in; otherwise fall back to global pumps
const ascendingOrderPumps = computed<XrefPumps>(() => {
  if (order?.value && order.value.length) {
    return order.value;
  }
  return [...descendingOrderPumps.value].reverse();
});

const pumpRowHeader = usePumpRowHeader(xrefPump, ascendingOrderPumps);
</script>
